export default function GraphViewer({ symbol, onBack }) {
  const urlMap = {
    sp500: process.env.PUBLIC_URL + '/images/GraphViewer__sp500_forecast_subplots.png',
    nasdaq: process.env.PUBLIC_URL + '/images/GraphViewer__nasdaq_forecast_subplots.png',
  };
  const imgUrl = urlMap[symbol];

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <button onClick={onBack} className="back-link">
        Back to Stock Index Project Description
      </button>
      <h1>{symbol.toUpperCase()} Forecast</h1>
      <img src={imgUrl} alt={`${symbol} forecast`} style={{ width: '100%', maxWidth: 1000 }} />
    </div>
  );
}
